import { useCachedActions } from '@hooks/useCachedActions';
import type { FetchData } from '@hooks/useDataFetcher';
import { buildCacheKey } from '@shared/util/cache-utils';
import { useMemo } from 'react';
import type { IPriceResponse } from 'types/custom';
import type { OfferPriceSearchRequest } from 'types/price-data';

import type { SnackbarActions } from './useSnackbar';

interface IState {
  loading: boolean;
}

interface IActions {
  searchPrices: (body: OfferPriceSearchRequest) => Promise<IPriceResponse>;
}

export type UsePriceData = (
  fetchData: FetchData,
  snackbar: SnackbarActions,
) => [IState, IActions];

export const usePriceData: UsePriceData = (makeRequest, snackbar) => {
  const { loading, createAction } = useCachedActions(snackbar);

  const actions = useMemo<IActions>(
    () => ({
      searchPrices: createAction(
        (body) => buildCacheKey('searchPrices', { body: JSON.stringify(body) }),
        (body: OfferPriceSearchRequest) =>
          makeRequest<IPriceResponse>(
            '/api/price-data/Offer/SearchPrices',
            undefined,
            'POST',
            body,
          ),
        {} as IPriceResponse,
      ),
    }),
    [createAction, makeRequest],
  );

  return [{ loading }, actions];
};
